import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

interface Tab {
  index: number;
  fieldNamesSync: string[];
}

@Injectable({
  providedIn: 'root'
})
export class GeliosFieldService {
  public clickedTab: BehaviorSubject<Tab> = new BehaviorSubject<Tab>(null);
  public switchRightTabs: BehaviorSubject<Tab> = new BehaviorSubject<Tab>(null);
  public switchLeftTabs: BehaviorSubject<Tab> = new BehaviorSubject<Tab>(null);
  public tabAddedFieldNames: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null);
}
